<!-- eslint-disable max-len -->
<template>
    <div class="c-call-to-action">
        <div class="c-call-to-action__wrapper">
            <y-row>
                <y-col
                    size="1"
                    class="c-call-to-action__wrapper__diamond-box"
                >
                    <img
                        src="@/assets/images/diamond.svg"
                        alt="diamond"
                        :style="`rotate: ${ $i18n.locale === 'ar' ? '60' : '0' }deg`"
                    >
                </y-col>
                <y-col
                    lg="10"
                    md="10"
                    sm="12"
                >
                    <h1
                        v-if="content.title"
                        class="c-call-to-action__title"
                    >
                        {{ content.title }}
                    </h1>
                </y-col>
                <y-col
                    size="1"
                    class="c-call-to-action__wrapper__diamond-box"
                >
                    <img
                        src="@/assets/images/diamond.svg"
                        alt="diamond"
                        :style="`rotate: ${ $i18n.locale === 'ar' ? '0' : '60' }deg`"
                    >
                </y-col>
            </y-row>

            <p class="c-call-to-action__synopsis">
                {{ content.synopsis }}
            </p>
            <p class="c-call-to-action__synopsis-mobile">
                {{ content.title2 || content.synopsis }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CallToAction',

        props: {
            content: Object,
        },
    };
</script>

<style lang="scss" src="./index.scss" />
